module.exports = __webpack_public_path__ + "static/media/small.a3ac7dda.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/small.mp4
// module id = 537
// module chunks = 8